/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_SubtitleInputs */

const en_tools_subtitle = /** @type {(inputs: Tools_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tool scores from hands-on experience. Updated regularly.`)
};

const id_tools_subtitle = /** @type {(inputs: Tools_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor AI tools berdasarkan pengalaman langsung. Diperbarui secara berkala.`)
};

/**
* | output |
* | --- |
* | "AI tool scores from hands-on experience. Updated regularly." |
*
* @param {Tools_SubtitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tools_subtitle = /** @type {((inputs?: Tools_SubtitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_SubtitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tools_subtitle(inputs)
	return en_tools_subtitle(inputs)
});